export default __webpack_public_path__ + "static/jobbox-3-b-121b73a92494863532163cc02ce2f50b.webp";